window.ProductBadges = window.ProductBadges || {};

window.ProductBadges.formatBadgeText = function formatBadgeText(tag) {
  if (!tag) return '';

  return String(tag)
    .replace(/^warm(?:[ _-]?)white$/i, 'Warm White')
    .replace(/^light(?:[ _-]?)blue(?:[ _-]?)led$/i, 'Light Blue LED')
    .replace(/^light(?:[ _-]?)green(?:[ _-]?)led$/i, 'Light Green LED')
    .replace(/^green(?:[ _-]?)led$/i, 'Green LED')
    .replace(/^yellow(?:[ _-]?)led$/i, 'Yellow LED')
    .replace(/^white(?:[ _-]?)led$/i, 'White LED')
    .replace(/^red(?:[ _-]?)led$/i, 'Red LED')
    .replace(/^orange(?:[ _-]?)led$/i, 'Orange LED')
    .replace(/^purple(?:[ _-]?)led$/i, 'Purple LED')
    .replace(/^pink(?:[ _-]?)led$/i, 'Pink LED')
    .replace(/^blue(?:[ _-]?)led$/i, 'Blue LED')
    .replace(/^navy(?:[ _-]?)led$/i, 'Navy LED')
    .replace(/^cool(?:[ _-]?)white$/i, 'Cool White')
    .replace(/^light(?:[ _-]?)effects$/i, 'Light Effects')
    .replace(/^sound(?:[ _-]?)effects$/i, 'Sound Effects')
    .replace(/^smoke(?:[ _-]?)effects$/i, 'Smoke Effects')
    .replace(/^rgb$/i, 'RGB')
    .replace(/^multi(?:[ _-]?)colou?red$/i, 'Multi-Coloured')
    .replace(/^promoalternative_/i, '')
    .replace(/^promoalternate_/i, '')
    .replace(/^promo_alternative_/i, '')
    .replace(/^promo_alternate_/i, '')
    .replace(/^promo_/i, '')
    .replace(/^gozney_/i, '')
    .replace(/^size_/i, '')
    .replace(/^freegift_/i, '')
    .replace(/^special_order$/i, 'Special Order')
    .replace(/_/g, ' ')
    .replace(/£\s*/g, '£')
    .trim();
};

window.ProductBadges.getBadgeTypeFromTag = function getBadgeTypeFromTag(tag) {
  const cleanTag = String(tag || '').trim().toLowerCase();
  const normalisedTag = cleanTag.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');

  if (normalisedTag === 'warm white' || normalisedTag === 'warmwhite') return 'warm-white';
  if (normalisedTag === 'light blue led' || normalisedTag === 'lightblueled') return 'light-blue-led';
  if (normalisedTag === 'light green led' || normalisedTag === 'lightgreenled') return 'light-green-led';
  if (normalisedTag === 'green led' || normalisedTag === 'greenled') return 'green-led';
  if (normalisedTag === 'yellow led' || normalisedTag === 'yellowled') return 'yellow-led';
  if (normalisedTag === 'white led' || normalisedTag === 'whiteled') return 'white-led';
  if (normalisedTag === 'red led' || normalisedTag === 'redled') return 'red-led';
  if (normalisedTag === 'orange led' || normalisedTag === 'orangeled') return 'orange-led';
  if (normalisedTag === 'purple led' || normalisedTag === 'purpleled') return 'purple-led';
  if (normalisedTag === 'pink led' || normalisedTag === 'pinkled') return 'pink-led';
  if (normalisedTag === 'blue led' || normalisedTag === 'blueled') return 'blue-led';
  if (normalisedTag === 'navy led' || normalisedTag === 'navyled') return 'navy-led';
  if (normalisedTag === 'cool white' || normalisedTag === 'coolwhite') return 'cool-white';
  if (normalisedTag === 'light effects' || normalisedTag === 'lighteffects') return 'light-effects';
  if (normalisedTag === 'sound effects' || normalisedTag === 'soundeffects') return 'sound-effects';
  if (normalisedTag === 'smoke effects' || normalisedTag === 'smokeeffects') return 'smoke-effects';
  if (cleanTag === 'rgb') return 'rgb';
  if (normalisedTag === 'multi coloured' || normalisedTag === 'multicoloured' || normalisedTag === 'multi colored' || normalisedTag === 'multicolored') return 'multi-coloured';
  if (cleanTag === 'presale') return 'presale';
  if (cleanTag === 'special_order') return 'special-order';
  if (cleanTag.startsWith('promo_')) return 'promo';
  if (cleanTag.startsWith('promoalternative_')) return 'promo';
  if (cleanTag.startsWith('promoalternate_')) return 'promo';
  if (cleanTag.startsWith('promo_alternative_')) return 'promo';
  if (cleanTag.startsWith('promo_alternate_')) return 'promo';
  if (cleanTag.startsWith('gozney_')) return 'gozney';
  if (cleanTag.startsWith('size_')) return 'size';
  if (cleanTag.startsWith('freegift_')) return 'freegift';

  return '';
};

window.ProductBadges.ledBadgeTypes = [
  'light-blue-led',
  'light-green-led',
  'orange-led',
  'red-led',
  'green-led',
  'blue-led',
  'navy-led',
  'multi-coloured',
  'rgb',
  'pink-led',
  'purple-led',
  'yellow-led',
  'white-led',
  'cool-white',
  'warm-white'
];

window.ProductBadges.isLedBadgeType = function isLedBadgeType(type) {
  return window.ProductBadges.ledBadgeTypes.includes(type);
};

/* Effects are a separate badge family, but intentionally share the
   product-search cross-fade rotator with LED colour badges. */
window.ProductBadges.effectBadgeTypes = [
  'light-effects',
  'sound-effects',
  'smoke-effects'
];

window.ProductBadges.isEffectBadgeType = function isEffectBadgeType(type) {
  return window.ProductBadges.effectBadgeTypes.includes(type);
};

window.ProductBadges.rotatingBadgeTypes = window.ProductBadges.ledBadgeTypes.concat(
  window.ProductBadges.effectBadgeTypes
);

window.ProductBadges.isRotatingBadgeType = function isRotatingBadgeType(type) {
  return window.ProductBadges.rotatingBadgeTypes.includes(type);
};


/* Bottom-of-image strip badges. These do not participate in the normal
   product badge hierarchy or colour/effects rotator. */
window.ProductBadges.imageStripBadgeDefinitions = [
  {
    tag: 'regal winter castle',
    type: 'regal-winter-castle',
    text: 'Regal Winter Castle'
  },
  {
    tag: 'snowfall at the lodge',
    type: 'snowfall-at-the-lodge',
    text: 'Snowfall at the Lodge'
  },
  {
    tag: 'joyful tidings',
    type: 'joyful-tidings',
    text: 'Joyful Tidings'
  },
  {
    tag: 'winter rose garden',
    type: 'winter-rose-garden',
    text: 'Winter Rose Garden'
  }
];

window.ProductBadges.getImageStripBadgesFromTags = function getImageStripBadgesFromTags(tags) {
  const productTags = Array.isArray(tags)
    ? tags
    : String(tags || '')
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);

  const normalisedTags = new Set(
    productTags.map(function (tag) {
      return String(tag || '').trim().toLowerCase().replace(/\s+/g, ' ');
    })
  );

  return window.ProductBadges.imageStripBadgeDefinitions.filter(function (badge) {
    return normalisedTags.has(badge.tag);
  });
};

window.ProductBadges.initImageStripBadges = function initImageStripBadges(root) {
  if (typeof document === 'undefined') return;

  const scope = root && root.querySelectorAll ? root : document;
  const strips = [];

  if (scope.matches && scope.matches('[data-product-image-strip-badges]')) {
    strips.push(scope);
  }

  scope.querySelectorAll('[data-product-image-strip-badges]').forEach(function (strip) {
    strips.push(strip);
  });

  strips.forEach(function (strip) {
    if (strip.dataset.productImageStripMounted === 'true') return;

    const card = strip.closest(
      '.spf-product-card, .card-wrapper, .card, .product-card, .grid__item'
    );

    if (!card) return;

    const imageHost = card.querySelector(
      '.spf-product-card__image-wrapper, ' +
      '.card__media .media, ' +
      '.card__media, ' +
      '.product-card__image-wrapper, ' +
      '.product-card__media'
    );

    if (!imageHost) return;

    imageHost.classList.add('product-image-strip-host');
    strip.classList.add('is-mounted');
    strip.dataset.productImageStripMounted = 'true';

    if (strip.parentNode !== imageHost) {
      imageHost.appendChild(strip);
    }
  });
};

window.ProductBadges.getBadgesFromTags = function getBadgesFromTags(tags, options) {
  const settings = options || {};
  const productTags = Array.isArray(tags)
    ? tags
    : String(tags || '')
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);

  const badges = [];

  const showSoldOut = settings.showSoldOut !== false;
  const showSale = settings.showSale !== false;
  const showPresale = settings.showPresale !== false;
  const showCustom = settings.showCustom !== false;

  if (showSoldOut && settings.isSoldOut) {
    badges.push({
      type: 'sold-out',
      text: 'Sold out'
    });
  }

  if (showSale && settings.hasSalePrice) {
    badges.push({
      type: 'sale',
      text: settings.saleText || 'Sale'
    });
  }

  if (
    showPresale &&
    productTags.some(function (tag) {
      return String(tag).trim().toLowerCase() === 'presale';
    })
  ) {
    badges.push({
      type: 'presale',
      text: settings.presaleText || 'Pre-order'
    });
  }

  if (showCustom) {
    productTags.forEach(function (tag) {
      const type = window.ProductBadges.getBadgeTypeFromTag(tag);

      if (!type || type === 'presale') return;

      const text = window.ProductBadges.formatBadgeText(tag);

      if (!text) return;

      badges.push({
        type: type,
        text: text
      });
    });
  }

  const singleBadgeLocations = ['product-card'];

  if (singleBadgeLocations.includes(settings.location)) {
  const priority = {
    'sold-out': 99,
    'special-order': 23,
    'freegift': 22,
    'light-blue-led': 21,
    'light-green-led': 20,
    'orange-led': 19,
    'red-led': 18,
    'green-led': 17,
    'blue-led': 16,
    'navy-led': 15,
    'multi-coloured': 14,
    'rgb': 14,
    'pink-led': 13,
    'purple-led': 12,
    'yellow-led': 11,
    'white-led': 10,
    'cool-white': 9,
    'warm-white': 8,
    'light-effects': 7,
    'sound-effects': 6,
    'smoke-effects': 5,
    'size': 4,
    'gozney': 3,
    'promo': 2,
    'sale': 1
  };

    const visibleBadges = badges
      .filter(function (badge) {
        return badge.type !== 'presale';
      })
      .sort(function (a, b) {
        return (priority[b.type] || 0) - (priority[a.type] || 0);
      });

    if (settings.rotateLedBadges === true) {
      const fixedOverrideTypes = ['sold-out', 'special-order', 'freegift'];
      const fixedOverride = visibleBadges.find(function (badge) {
        return fixedOverrideTypes.includes(badge.type);
      });

      if (fixedOverride) return [fixedOverride];

      const seenRotatingTypes = new Set();
      const rotatingBadges = visibleBadges.filter(function (badge) {
        if (!window.ProductBadges.isRotatingBadgeType(badge.type)) return false;
        if (seenRotatingTypes.has(badge.type)) return false;
        seenRotatingTypes.add(badge.type);
        return true;
      });

      if (rotatingBadges.length) return rotatingBadges;
    }

    return visibleBadges.slice(0, 1);
  }

  return badges;
};

window.ProductBadges.renderBadges = function renderBadges(tags, options) {
  const settings = options || {};
  const location = settings.location || 'default';
  const badges = window.ProductBadges.getBadgesFromTags(tags, settings);

  if (!badges.length) return '';

  const shouldRotateBadges =
    settings.rotateLedBadges === true &&
    location === 'product-card' &&
    badges.length > 1 &&
    badges.every(function (badge) {
      return window.ProductBadges.isRotatingBadgeType(badge.type);
    });

  const wrapperClasses = [
    'product-badges',
    `product-badges--${location}`
  ];

  if (shouldRotateBadges) {
    wrapperClasses.push('product-badges--badge-rotator');
    /* Legacy class retained so older theme CSS remains compatible. */
    wrapperClasses.push('product-badges--led-rotator');
  }

  const wrapperAttributes = shouldRotateBadges
    ? ` data-product-badge-rotator data-product-badge-led-rotator data-badge-rotation-interval="${Number(settings.ledRotationInterval) || 3200}" data-led-rotation-interval="${Number(settings.ledRotationInterval) || 3200}"`
    : '';

  return `
    <div class="${wrapperClasses.join(' ')}"${wrapperAttributes}>
      ${badges
        .map(function (badge, index) {
          const rotatingClass = shouldRotateBadges
            ? ' product-badge--rotating product-badge--led-rotating'
            : '';
          const activeClass = shouldRotateBadges && index === 0 ? ' is-active' : '';
          return `<span class="product-badge product-badge--${badge.type} product-badge--${location}${rotatingClass}${activeClass}">${badge.text}</span>`;
        })
        .join('')}
    </div>
  `;
};

/* Generic colour/effects rotator. The old initLedRotators name is kept
   as an alias for backwards compatibility with existing theme code. */
window.ProductBadges.initBadgeRotators = function initBadgeRotators(root, force) {
  if (typeof document === 'undefined') return;

  const scope = root && root.querySelectorAll ? root : document;
  const rotators = [];
  const selector = '[data-product-badge-rotator], [data-product-badge-led-rotator]';

  if (scope.matches && scope.matches(selector)) {
    rotators.push(scope);
  }

  scope.querySelectorAll(selector).forEach(function (rotator) {
    if (!rotators.includes(rotator)) rotators.push(rotator);
  });

  rotators.forEach(function (rotator) {
    const rotatingBadges = Array.from(
      rotator.querySelectorAll('.product-badge--rotating, .product-badge--led-rotating')
    ).filter(function (badge, index, allBadges) {
      return allBadges.indexOf(badge) === index;
    });

    if (!rotatingBadges.length) return;

    const signature = rotatingBadges
      .map(function (badge) {
        return badge.className + ':' + badge.textContent.trim();
      })
      .join('|');

    if (
      force !== true &&
      rotator.dataset.badgeRotatorReady === 'true' &&
      rotator.dataset.badgeRotatorSignature === signature
    ) {
      return;
    }

    if (rotator._productBadgeLedTimer) {
      window.clearInterval(rotator._productBadgeLedTimer);
      rotator._productBadgeLedTimer = null;
    }
    if (rotator._productBadgeTimer) {
      window.clearInterval(rotator._productBadgeTimer);
      rotator._productBadgeTimer = null;
    }

    rotator.dataset.badgeRotatorReady = 'true';
    rotator.dataset.ledRotatorReady = 'true';
    rotator.dataset.badgeRotatorSignature = signature;

    let activeIndex = 0;
    rotatingBadges.forEach(function (badge, index) {
      badge.classList.toggle('is-active', index === 0);
    });

    if (rotatingBadges.length < 2) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const interval =
      Number(rotator.dataset.badgeRotationInterval) ||
      Number(rotator.dataset.ledRotationInterval) ||
      3200;

    rotator._productBadgeTimer = window.setInterval(function () {
      rotatingBadges[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % rotatingBadges.length;
      rotatingBadges[activeIndex].classList.add('is-active');
    }, interval);

    /* Retain the legacy timer property too. */
    rotator._productBadgeLedTimer = rotator._productBadgeTimer;
  });
};

window.ProductBadges.initLedRotators = function initLedRotators(root, force) {
  return window.ProductBadges.initBadgeRotators(root, force);
};

window.ProductBadges.observeLedRotators = function observeLedRotators() {
  if (typeof document === 'undefined' || window.ProductBadges._ledRotatorObserverInstalled) return;

  window.ProductBadges._ledRotatorObserverInstalled = true;
  window.ProductBadges.initBadgeRotators(document);
  window.ProductBadges.initImageStripBadges(document);

  if (!document.body || typeof MutationObserver === 'undefined') return;

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          window.ProductBadges.initBadgeRotators(node);
          window.ProductBadges.initImageStripBadges(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  window.ProductBadges._ledRotatorObserver = observer;
};

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.ProductBadges.observeLedRotators();
    });
  } else {
    window.ProductBadges.observeLedRotators();
  }
}

window.ProductBadges.normaliseTags = function normaliseTags(tags) {
  return Array.isArray(tags)
    ? tags
    : String(tags || '')
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);
};

window.ProductBadges.hasPromoTag = function hasPromoTag(tags) {
  const productTags = window.ProductBadges.normaliseTags(tags);

  return productTags.some(function (tag) {
    const cleanTag = String(tag || '').trim().toLowerCase();

    return (
      cleanTag.startsWith('promo_') ||
      cleanTag.startsWith('promoalternative_') ||
      cleanTag.startsWith('promoalternate_') ||
      cleanTag.startsWith('promo_alternative_') ||
      cleanTag.startsWith('promo_alternate_')
    );
  });
};

window.ProductBadges.hasGozneyDiscountTag = function hasGozneyDiscountTag(tags) {
  const productTags = window.ProductBadges.normaliseTags(tags);

  return productTags.some(function (tag) {
    return String(tag || '').trim().toLowerCase() === 'gozney_20%_off';
  });
};